import { v4 as uuidv4 } from 'uuid';
import i18n from '../../../i18n';
import { LabelPrintScenarioGrid } from './LabelPrintScenarioGrid';
import { LabelPrintScenarioGridPluginSettings } from './LabelPrintScenarioGridPluginSettings';

const t = (value: string) => i18n.t('sidePanel.' + value)

export const LabelPrintScenarioTab = (): ITab => {
    return {
        id: uuidv4(),
        title: t('service.submenu.labelPrintScenario'),
        view: {
            content: LabelPrintScenarioGridPluginSettings
                ? <LabelPrintScenarioGrid gridId={uuidv4()} plugin={LabelPrintScenarioGridPluginSettings} />
                : <p> Справочник не настроен</p>
        }
    }
}